"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const context_1 = require("src/context/context");
const TranslationProvider_1 = require("src/providers/TranslationProvider");
const ButtonWithIcon_1 = tslib_1.__importDefault(require("src/components/buttons/ButtonWithIcon"));
const MediaFilePreview_1 = tslib_1.__importDefault(require("src/components/files/MediaFilePreview"));
const ContractPreview = (props) => {
    const { translate } = (0, TranslationProvider_1.useTranslation)();
    const [openedFilePreview, setOpenedFilePreview] = (0, react_1.useState)(null);
    const { toast } = (0, context_1.useToastContext)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [openedFilePreview
                ? (0, jsx_runtime_1.jsx)(MediaFilePreview_1.default, { setOpenedFilePreview: setOpenedFilePreview, openedFilePreview: openedFilePreview }, props.uid)
                : null, (0, jsx_runtime_1.jsx)(ButtonWithIcon_1.default, { name: translate('view_employment_contract', 'შრომითი ხელშეკრულების ნახვა'), small: true, icon: 'fas fa-file-pdf', onClick: () => {
                    props.mediaFileHook.getFileProperties(props.uid, 'pdf')
                        .then(response => {
                        if (response && response.errors !== null)
                            response.errors.forEach(el => toast.danger(el.message));
                        if (response !== null)
                            setOpenedFilePreview(response);
                    });
                } })] }));
};
exports.default = ContractPreview;
